module.exports = __webpack_public_path__ + "img/img1.1368b7c7.png";